import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import './BreadcrumbsConversations.scss';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

class BreadcrumbsConversations extends PureComponent {
  render() {
    const {
      t,
      selectedItemBrand,
      selectedItemModel,
      selectedItemSubFolder,
      selectedItemHashId,
      selectedItemShowPath,
      history,
    } = this.props;
    const modelText = `${selectedItemBrand} ${selectedItemModel}  | `;
    const shouldInfoShow = Boolean(selectedItemHashId);
    const handleHashIdClick = () => {
      if (selectedItemShowPath) {
        history.push({
          pathname: selectedItemShowPath,
          state: { whichFolder: selectedItemSubFolder, },
        });
      }
    };
    return (
      <div className="main-area__header conversations-breadcrumbs">
        <div className="details__menu">
          <span className="conversation-tab">{t('conversations')}</span>
          {shouldInfoShow && (
            <span className="conversation-info">
              <span>{modelText}</span>
              <span>
                <a onClick={() => handleHashIdClick()} style={{ cursor: selectedItemShowPath ? 'pointer' : 'auto', }}>
                  {selectedItemHashId}
                </a> |
              </span>
            </span>
          )}
        </div>
      </div>
    );
  }
}

BreadcrumbsConversations.propTypes = {
  t: PropTypes.func.isRequired,
  selectedItemShowPath: PropTypes.string,
  selectedItemSubFolder: PropTypes.string,
  history: PropTypes.object.isRequired,
  selectedItemBrand: PropTypes.string,
  selectedItemModel: PropTypes.string,
  selectedItemHashId: PropTypes.string,
};

BreadcrumbsConversations.defaultProps = {
  selectedItemBrand: '',
  selectedItemModel: '',
  selectedItemFolder: '',
  selectedItemHashId: '',
  selectedItemSubFolder: '',
  selectedItemShowPath: '',
};

const mapStateToProps = (state) => {
  const selectedItemHashId = get(state, ['conversations', 'selectedItemHashId']);
  const selectedConversation = get(state, ['conversations', 'conversations', selectedItemHashId]);
  if (selectedConversation) {
    return {
      selectedItemBrand: get(selectedConversation, 'brand'),
      selectedItemModel: get(selectedConversation, 'model'),
      selectedItemSubFolder: get(selectedConversation, 'sub_folder'),
      selectedItemShowPath: get(selectedConversation, 'show_path'),
      selectedItemHashId,
    };
  }
  return {};
};

export default compose(withRouter, connect(mapStateToProps), withScopedTranslations('breadcrumbs.conversations'))(BreadcrumbsConversations);
